import { PERMISSIONS } from "./constants";

export const getClaimPermissions = () => {
    const userProfile = JSON.parse(sessionStorage.getItem('SettingProfile'));
    return userProfile.permissions;
}

export const getUserProfile = () => {
    return JSON.parse(sessionStorage.getItem('SettingProfile'));
}

export const getAgenciesFromSetting = () => {
    return JSON.parse(sessionStorage.getItem('SettingAgencies'));
}

export const getAgenciesExistEndpointsFromSetting = () => {
    return JSON.parse(sessionStorage.getItem('SettingAgenciesWithEndpoints'));
} 

export const getSettingSuperAdminRole = () => {
    return JSON.parse(sessionStorage.getItem('SettingSuperAdminRole'));
}

export const getSuperAdminEmailDomains = () => {
    return JSON.parse(sessionStorage.getItem('SuperAdminEmailDomains'));
}

export const getMaxAclDuration = () => {
    return JSON.parse(sessionStorage.getItem('MaxAclDuration'));
}

export const getMaxArchivedDuration = () => {
    return JSON.parse(sessionStorage.getItem('MaxArchivedDuration'));
}
export const getMaxArchivedExportDuration = () => {
    return JSON.parse(sessionStorage.getItem('MaxArchivedExportDuration'));
}

export const getSettingCrossAgencys = () => {
    return JSON.parse(sessionStorage.getItem('CrossAgencies'));
}

export const hasAccess= (requirePermissions) => {
    
    const claimPermissions = getClaimPermissions();
    
    let hasPermission;
      const commonRoutes = requirePermissions.filter((x) => claimPermissions.indexOf(x) !== -1);
  
       hasPermission = requirePermissions.every(function (element) {
        return commonRoutes.includes(element);
      });
     
      return hasPermission;
}

export const hasSuperAdminAccess = () => hasAccess([PERMISSIONS.GeneralAccess]);



